import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { Alerts } from "../utils/alerts";
import { obtenerValorDeLaCookie, removeAllCookies } from "../utils/helpers";
import { process } from "process";

const baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

axios.interceptors.request.use(
  (config) => {
    const accessToken = obtenerValorDeLaCookie("AccessTokenCookie");
    if (accessToken) {
      config.headers["Cookie: AccessTokenCookie"] = accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response &&
  axios.interceptors.response.use(
    function (response) {
      if (!Cookies.get("isIn")) Cookies.set("isIn", "true", { path: "/" });
      return response;
    },
    async function (error) {
      if (error.response) {
        const status = error.response.status;

        switch (status) {
          case 401:
            await handleUnauthorized();
            break;
          case 400:
            toast.error("Ha ocurrido un error.", {
              /* Opciones del toast */
            });
            break;
          default:
            return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );

const handleUnauthorized = async () => {
  const result = await Alerts.confirmationAlert({
    title: "Sesión Expirada",
    text: "Tu sesión ha expirado, ¿Desea iniciar sesion nuevamente?",
    icon: "warning",
    allowOutClick: false,
  });
  if (result.value) {
    return window.location.replace("/");
  } else {
    localStorage.clear();
    window.location.pathname = "/UnAuthorized";
  }
};

const cancelSource = axios.CancelToken.source();
const cancelRequest = () => {
  return cancelSource.cancel();
};

const get = async (endpoint) => {
  return axios.get(`${baseURL}${endpoint}`, { withCredentials: true });
};

const downloadFile = async (endpoint) => {
  return axios.get(`${baseURL}${endpoint}`, {
    withCredentials: true,
    responseType: "blob",
  });
};

const getWithParams = async (endpoint, queryParams) => {
  return axios.get(`${baseURL}${endpoint}`, {
    params: queryParams,
    withCredentials: true,
  });
};

const patch = async (endpoint, data) => {
  return await axios.patch(`${baseURL}${endpoint}`, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
};

const post = async (endpoint, data) => {
  return axios.post(`${baseURL}${endpoint}`, data, {
    cancelToken: cancelSource.token,
    mode: "no-cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
};

const postFormData = async (endpoint, data) => {
  return axios.post(`${baseURL}${endpoint}`, data, {
    cancelToken: cancelSource.token,
    mode: "no-cors",
    withCredentials: true,
  });
};

const deleteRequest = async (endpoint, data) => {
  try {
    const response = await axios.delete(`${baseURL}${endpoint}`, {
      data: data,
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getEnums = async (endpoint) => {
  return axios.get(`${baseURL}Enum/${endpoint}`);
};

const getEnumById = async (endpoint, id) => {
  return axios.get(`${baseURL}Enum/${endpoint}/${id}`);
};

const getById = async (endpoint, id) => {
  return axios.get(`${baseURL}${endpoint}${id}`, {
    withCredentials: true,
  });
};

const convertToQueryString = (filters) => {
  let queryString = "";
  if (filters != undefined) {
    queryString = Object.keys(filters)
      .map((key) =>
        filters[key] != undefined && filters[key] != ""
          ? key + "=" + filters[key]
          : null
      )
      .filter((item) => item != null)
      .join("&");
  }
  return queryString;
};
export {
  get,
  downloadFile,
  post,
  cancelRequest,
  getEnums,
  getEnumById,
  getById,
  convertToQueryString,
  postFormData,
  getWithParams,
  patch,
  deleteRequest,
};
